import { useLocation } from 'react-router-dom';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';

export default function AccountAccess({ user, token, ready, error, onRetry, onLogout, children }) {
  const { pathname } = useLocation();
  const protectedPage = /^\/(dashboard|adviser|user-settings|projects)(\/|$)/.test(pathname);
  if (!token || !protectedPage) return children;
  if (error) return <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background text-foreground"><p role="alert">We couldn't check your account access.</p><Button onClick={onRetry}>Try again</Button><Button variant="outline" onClick={onLogout}>Sign out</Button></div>;
  if (!ready) return <div className="min-h-screen grid place-items-center bg-background text-foreground" role="status">Checking account access…</div>;
  if (user?.account_status !== 'paused') return children;
  return (
    <>
      <div aria-hidden="true" className="min-h-screen bg-background p-6 sm:p-12 opacity-30 pointer-events-none select-none blur-sm">
        <div className="h-16 border-b border-border text-xl font-bold">Dashboard</div>
        <div className="grid sm:grid-cols-3 gap-6 mt-10">{[1, 2, 3].map(item => <div key={item} className="h-36 rounded-2xl bg-muted" />)}</div>
      </div>
      <Dialog open>
        <DialogContent className="w-[calc(100%-2rem)] rounded-2xl [&>button:last-child]:hidden" onEscapeKeyDown={event => event.preventDefault()} onInteractOutside={event => event.preventDefault()}>
          <DialogTitle className="text-xl sm:text-2xl">Your account is temporarily paused</DialogTitle>
          <DialogDescription className="leading-relaxed">
            An administrator has paused your account. This may be related to a security concern or a technical issue. Data access and project creation are unavailable until access is restored. Please contact support for details.
          </DialogDescription>
          <a className="inline-flex items-center justify-center min-h-11 rounded-xl bg-[#FEAB3D] text-[#021426] font-bold px-5" href="mailto:info@aisearchadvisers.com?subject=Account%20paused%20%E2%80%94%20support%20request">Contact support</a>
          <p className="text-sm text-muted-foreground break-all">info@aisearchadvisers.com</p>
          <Button variant="outline" onClick={onLogout}>Sign out</Button>
          <p className="text-xs text-muted-foreground">This page will update automatically when access is restored.</p>
        </DialogContent>
      </Dialog>
    </>
  );
}
